import { LOGIN, LOGIN_SUCCESS, LOGIN_FAILED, REFRESH_TOKEN, REFRESH_TOKEN_SUCCESS, REFERSH_TOKEN_FAILED } from "./actionTypes"

const localUser = JSON.parse(localStorage.getItem('user'))

let initialState = {
    user: {},
    loading: false,
    success: false,
    error: ''
}
if(localUser){
    initialState.user = localUser
    initialState.success = true
}

export const authenticationReducer = (state=initialState, action) => {
    switch(action.type){
        case LOGIN : return {
            ...state,
            user: {},
            loading: true,
            success: false,
            error: ''
        }
        case LOGIN_SUCCESS : return {
            ...state,
            user: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case LOGIN_FAILED : return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case REFRESH_TOKEN : return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case REFRESH_TOKEN_SUCCESS : return  {
            ...state,
            user: {
                ...state.user,
                accessToken: action.payload
            },
            loading: false,
            success: true
        }
        case REFERSH_TOKEN_FAILED : return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        default : return state
    }
}